import { axiosBeelineRequest } from '@beef/utils';

export const fetchWrongRegionPopup = (url, params) =>
  axiosBeelineRequest({
    url,
    params,
    originalResponse: false,
  });
